import { updateDocRejectProfile } from './states';

export const services = {
  updateDocRejectProfile,
};
